import styled from 'styled-components';
import { colors } from 'globalStyles';
import { media } from 'utils/style-utils'

export const StyledTooltip = styled.div`
  position: relative;
  display: inline-block;
  font-weight: ${({ weight }) => (weight ? weight : "bold")};
  font-size: ${({ size }) => (size ? size : "8px")};

  &:hover > span {
    visibility: visible;
  }
`;

export const Text = styled.span`
  text-transform: ${({ casing }) => casing};
  visibility: hidden;
  background-color: rgba(104, 129, 144, .9);
  color: ${colors.WHITE};
  overflow-wrap: break-word;
  text-align: center;
  padding: 6px 10px 5px;
  border-radius: 4px;
  left: 25px;
  top: -7px;
  position: absolute;
  z-index: 1000;
  ${({ width }) => `width: ${width};`}
  ${({ offset }) => `margin-top: ${offset};`}

  &:after {
    content: " ";
    position: absolute;
    top: 15px;
    right: 100%;
    margin-top: -4px;
    border-width: 4px;
    border-style: solid;
    border-color: transparent rgba(104, 129, 144, 0.9) transparent transparent;
  }

  &.bottom {
    left: auto;
    right: -5px;
    top: 20px;
    margin: 0;

    &:after {
      top: 0;
      right: 8px;
      margin-top: -7px;
      transform: rotate(90deg);
    }
  }

  ${media.mobile`
    left: auto;
    right: -5px;
    top: 20px;
    margin: 0;

    &:after {
      top: 0;
      right: 8px;
      margin-top: -7px;
      transform: rotate(90deg);
    }
  `}
`;

export const Content = styled.div``;
